// @flow

import * as React from 'react';

type SeparatorProps = {|
  items: Array<string | React.Node>,
  render?: (s: React.Node) => React.Node,
  separator?: string,
|};

export const NOOP_RENDER = (item: React.Node) => item;

export const Separator = ({
  items,
  render = NOOP_RENDER,
  separator = ', ',
}: SeparatorProps) => (
  <React.Fragment>
    {items.map((item, index) => [index > 0 && separator, render(item)])}
  </React.Fragment>
);
